module.exports = __webpack_public_path__ + "static/media/ev-gpjvRZyavZc-unsplash.0c9bc66a.jpg";